import { z } from "zod";

const httpUrl = z.string().regex(/^https?:\/\//i);

export const ProductSchema = z.object({
  title: z.string().min(1),
  brand: z.string().min(1),
  description: z.string(),
  price: z.number(),
  priceMax: z.number().optional(),
  currency: z.string().default("USD"),
  imageUrl: httpUrl.nullable().optional(),
  productUrl: httpUrl,
  available: z.boolean().default(true),
  rating: z.number().optional(),
  ratingCount: z.number().optional(),
});

export const ProductResultSchema = z.object({
  products: z.array(ProductSchema).min(1),
});

export type Product = z.infer<typeof ProductSchema>;
export type ProductResult = z.infer<typeof ProductResultSchema>;

export function validateProductResult(value: unknown): ProductResult | null {
  const parsed = ProductResultSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
